import * as React from "react";

import * as Constants from "../../../Constants";
import { SiblingsState, StateRoot } from "../../../Models";
import { OutotecIcons } from "../../General/Icons/";
import azureStore from "../../../Store/azureStore";
import filterItemsStore from "../../../Store/filterItems";
import * as Models from "../../../Models";
import { getToggleButtonActive } from "../../../Helpers/azure";

export default function ToggleSiblingsButtons({
    match,
}: {
    match: Models.Match;
}) {
    const currentFilterItems = filterItemsStore((s) => s.currentFilterItems);
    const toggleItemSiblings = filterItemsStore((s) => s.toggleItemSiblings);
    const filterItems = currentFilterItems(match.params);
    const loading = azureStore().getIsLoading();
    function toggleSiblings(e: any, open: boolean): void {
        e.stopPropagation();

        if (loading) {
            return;
        }

        const siblings: SiblingsState = {
            node: undefined,
            open,
        };
        toggleItemSiblings(siblings, match.params);
    }

    const buttonDisabled: string =
        getToggleButtonActive(filterItems, match.params) && !loading
            ? "CollapseArea__button--enabled"
            : "CollapseArea__button--disabled";

    return (
        <div className="CollapseArea">
            <span
                className={`CollapseArea__button ${buttonDisabled}`}
                onClick={(e) => {
                    toggleSiblings(e, true);
                }}
            >
                <OutotecIcons type={Constants.OPEN_SIBLINGS} />
                <span className="CollapseArea__buttonText">Expand</span>
            </span>
            <span
                className={`CollapseArea__button ${buttonDisabled}`}
                onClick={(e) => {
                    toggleSiblings(e, false);
                }}
            >
                <OutotecIcons type={Constants.CLOSE_SIBLINGS} />
                <span className="CollapseArea__buttonText">Collapse</span>
            </span>
        </div>
    );
}
